import { render, staticRenderFns } from "./CumplimientoPresupuesto.vue?vue&type=template&id=638654b5&scoped=true"
import script from "./CumplimientoPresupuesto.vue?vue&type=script&lang=js"
export * from "./CumplimientoPresupuesto.vue?vue&type=script&lang=js"
import style0 from "./CumplimientoPresupuesto.vue?vue&type=style&index=0&id=638654b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638654b5",
  null
  
)

export default component.exports